import { 
    useContext, 
} from "react";
import { Dialog } from "@mui/material";
import { Container } from "./container";
import { DndProvider } from 'react-dnd'
import { HTML5Backend } from 'react-dnd-html5-backend'
import { DrawerContext } from "../../context/drawerContext";
import { MenuOrderingContainer } from "../menuOrdering/menuOrderingContainer";

export function MenuOrderingEstadosContainer() {
const {
    showMenuOrderingEstados,
    handleCloseMenuOrderingEstados,
} = useContext(DrawerContext);

    return (
        <Dialog
        onClose={handleCloseMenuOrderingEstados} 
        open={showMenuOrderingEstados}
        >
            <DndProvider backend={HTML5Backend}>
                <Container 
                />
            </DndProvider>
            <MenuOrderingContainer 
            />
        </Dialog>
    )
}